export const GET_STORE_CONFIGS_START = 'GET_STORE_CONFIGS_START';
export const GET_STORE_CONFIGS_SUCCESS = 'GET_STORE_CONFIGS_SUCCESS';
export const GET_STORE_CONFIGS_FAILED = 'GET_STORE_CONFIGS_FAILED';

export const UPDATE_STORE_CONFIGS_START = 'UPDATE_STORE_CONFIGS_START';
export const UPDATE_STORE_CONFIGS_SUCCESS = 'UPDATE_STORE_CONFIGS_SUCCESS';
export const UPDATE_STORE_CONFIGS_FAILED = 'UPDATE_STORE_CONFIGS_FAILED';

export const UPDATE_STORE_SITE_MAP_START = 'UPDATE_STORE_SITE_MAP_START';
export const UPDATE_STORE_SITE_MAP_SUCCESS = 'UPDATE_STORE_SITE_MAP_SUCCESS';
export const UPDATE_STORE_SITE_MAP_FAILED = 'UPDATE_STORE_SITE_MAP_FAILED';

export const GET_REWARD_BEHAVIOR_RULES_START = 'GET_REWARD_BEHAVIOR_RULES_START';
export const GET_REWARD_BEHAVIOR_RULES_SUCCESS = 'GET_REWARD_BEHAVIOR_RULES_SUCCESS';
export const GET_REWARD_BEHAVIOR_RULES_FAILED = 'GET_REWARD_BEHAVIOR_RULES_FAILED';

export const UPDATE_REWARD_BEHAVIOR_RULE_START = 'UPDATE_REWARD_BEHAVIOR_RULE_START';
export const UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS = 'UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS';
export const UPDATE_REWARD_BEHAVIOR_RULE_FAILED = 'UPDATE_REWARD_BEHAVIOR_RULE_FAILED';

export const CHANGE_STORE_CONFIGS = 'CHANGE_STORE_CONFIGS';
export const CHANGE_HOMEPAGE_PROMO_CAROUSEL_CONFIG = 'CHANGE_HOMEPAGE_PROMO_CAROUSEL_CONFIG';
export const CHANGE_HOMEPAGE_CAROUSEL_BUTTON_CATEGORY = 'CHANGE_HOMEPAGE_CAROUSEL_BUTTON_CATEGORY';

export const GET_FOLLOW_UP_EMAILS_START = 'GET_FOLLOW_UP_EMAILS_START';
export const GET_FOLLOW_UP_EMAILS_SUCCESS = 'GET_FOLLOW_UP_EMAILS_SUCCESS';
export const GET_FOLLOW_UP_EMAILS_FAILED = 'GET_FOLLOW_UP_EMAILS_FAILED';

export const SAVE_NOTIFICATION_OPTIONS_START = 'SAVE_NOTIFICATION_OPTIONS_START';
export const SAVE_NOTIFICATION_OPTIONS_SUCCESS = 'SAVE_NOTIFICATION_OPTIONS_SUCCESS';
export const SAVE_NOTIFICATION_OPTIONS_WARNING = 'SAVE_NOTIFICATION_OPTIONS_WARNING';
export const SAVE_NOTIFICATION_OPTIONS_FAILED = 'SAVE_NOTIFICATION_OPTIONS_FAILED';

export const CHANGE_CAMPAIGN_EMAIL_CONFIGS = 'CHANGE_CAMPAIGN_EMAIL_CONFIGS';

export const GET_SOCIAL_MEDIA_CONFIGS_START = 'GET_SOCIAL_MEDIA_CONFIGS_START';
export const GET_SOCIAL_MEDIA_CONFIGS_SUCCESS = 'GET_SOCIAL_MEDIA_CONFIGS_SUCCESS';
export const GET_SOCIAL_MEDIA_CONFIGS_FAILED = 'GET_SOCIAL_MEDIA_CONFIGS_FAILED';

export const CHANGE_SOCIAL_MEDIA_CONFIG = 'CHANGE_SOCIAL_MEDIA_CONFIG';

export const SAVE_SOCIAL_MEDIA_CONFIGS_START = 'SAVE_SOCIAL_MEDIA_CONFIGS_START';
export const SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS = 'SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS';
export const SAVE_SOCIAL_MEDIA_CONFIGS_FAILED = 'SAVE_SOCIAL_MEDIA_CONFIGS_FAILED';

export const GET_SURVEY_QUESTION_CONFIGS_START = 'GET_SURVEY_QUESTION_CONFIGS_START';
export const GET_SURVEY_QUESTION_CONFIGS_SUCCESS = 'GET_SURVEY_QUESTION_CONFIGS_SUCCESS';
export const GET_SURVEY_QUESTION_CONFIGS_FAILED = 'GET_SURVEY_QUESTION_CONFIGS_FAILED';

export const CHANGE_SURVEY_QUESTION_CONFIG = 'CHANGE_SURVEY_QUESTION_CONFIG';

export const GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_START = 'GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_START';
export const GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_SUCCESS = 'GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_FAILED = 'GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_FAILED';

export const GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START = 'GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START';
export const GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS = 'GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED = 'GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED';

export const CHANGE_HOMEPAGE_WELCOME_BLOCK_CONFIGS = 'CHANGE_HOMEPAGE_WELCOME_BLOCK_CONFIGS';

export const SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START = 'SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START';
export const SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED = 'SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED';

export const GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START = 'GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START';
export const GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS = 'GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED = 'GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED';

export const CHANGE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS = 'CHANGE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS';

export const SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START = 'SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START';
export const SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED = 'SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED';

export const GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START = 'GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START';
export const GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS = 'GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED = 'GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED';

export const CHANGE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS = 'CHANGE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS';

export const SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START = 'SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START';
export const SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED = 'SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED';

export const GET_HOMEPAGE_CTA_BLOCK_CONFIGS_START = 'GET_HOMEPAGE_CTA_BLOCK_CONFIGS_START';
export const GET_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS = 'GET_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED = 'GET_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED';

export const CHANGE_HOMEPAGE_CTA_BLOCK_CONFIGS = 'CHANGE_HOMEPAGE_CTA_BLOCK_CONFIGS';
export const CHANGE_HOMEPAGE_CTA_CATEGORY = 'CHANGE_HOMEPAGE_CTA_CATEGORY';

export const SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_START = 'SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_START';
export const SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED = 'SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED';

export const GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START = 'GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START';
export const GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS = 'GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED = 'GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED';

export const SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START = 'SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START';
export const SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED = 'SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED';

export const GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START = 'GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START';
export const GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS = 'GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED = 'GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED';

export const SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START = 'SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START';
export const SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED = 'SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED';

export const GET_HOMEPAGE_TESTIMONIALS_CONFIGS_START = 'GET_HOMEPAGE_TESTIMONIALS_CONFIGS_START';
export const GET_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS = 'GET_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED = 'GET_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED';

export const SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_START = 'SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_START';
export const SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED = 'SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED';

export const GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_START = 'GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_START';
export const GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS = 'GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED = 'GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED';

export const SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_START = 'SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_START';
export const SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED = 'SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED';

export const GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_START = 'GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_START';
export const GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS = 'GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED = 'GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED';

export const CHANGE_HOMEPAGE_PREMIUM_CTA_CONFIGS = 'CHANGE_HOMEPAGE_PREMIUM_CTA_CONFIGS';
export const CHANGE_HOMEPAGE_PREMIUM_CTA_CATEGORY = 'CHANGE_HOMEPAGE_PREMIUM_CTA_CATEGORY';

export const SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_START = 'SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_START';
export const SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED = 'SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED';

export const GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_START = 'GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_START';
export const GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS = 'GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS';
export const GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED = 'GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED';

export const CHANGE_HOMEPAGE_REWARD_BLOCK_CONFIGS = 'CHANGE_HOMEPAGE_REWARD_BLOCK_CONFIGS';

export const SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_START = 'SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_START';
export const SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS = 'SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS';
export const SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED = 'SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED';

export const GET_APPOINTMENT_FORM_CONFIGS_START = 'GET_APPOINTMENT_FORM_CONFIGS_START';
export const GET_APPOINTMENT_FORM_CONFIGS_SUCCESS = 'GET_APPOINTMENT_FORM_CONFIGS_SUCCESS';
export const GET_APPOINTMENT_FORM_CONFIGS_FAILED = 'GET_APPOINTMENT_FORM_CONFIGS_FAILED';

export const CHANGE_APPOINTMENT_FORM_CONFIGS = 'CHANGE_APPOINTMENT_FORM_CONFIGS';

export const SAVE_APPOINTMENT_FORM_CONFIGS_START = 'SAVE_APPOINTMENT_FORM_CONFIGS_START';
export const SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS = 'SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS';
export const SAVE_APPOINTMENT_FORM_CONFIGS_FAILED = 'SAVE_APPOINTMENT_FORM_CONFIGS_FAILED';

export const GET_ABOUT_US_PAGE_CONFIGS_START = 'GET_ABOUT_US_PAGE_CONFIGS_START';
export const GET_ABOUT_US_PAGE_CONFIGS_SUCCESS = 'GET_ABOUT_US_PAGE_CONFIGS_SUCCESS';
export const GET_ABOUT_US_PAGE_CONFIGS_FAILED = 'GET_ABOUT_US_PAGE_CONFIGS_FAILED';

export const CHANGE_ABOUT_US_PAGE_CONFIGS = 'CHANGE_ABOUT_US_PAGE_CONFIGS';

export const SAVE_ABOUT_US_PAGE_CONFIGS_START = 'SAVE_ABOUT_US_PAGE_CONFIGS_START';
export const SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS = 'SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS';
export const SAVE_ABOUT_US_PAGE_CONFIGS_FAILED = 'SAVE_ABOUT_US_PAGE_CONFIGS_FAILED';

export const GET_BEFORE_AFTER_GALLERY_CONFIGS_START = 'GET_BEFORE_AFTER_GALLERY_CONFIGS_START';
export const GET_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS = 'GET_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS';
export const GET_BEFORE_AFTER_GALLERY_CONFIGS_FAILED = 'GET_BEFORE_AFTER_GALLERY_CONFIGS_FAILED';

export const SAVE_BEFORE_AFTER_GALLERY_CONFIGS_START = 'SAVE_BEFORE_AFTER_GALLERY_CONFIGS_START';
export const SAVE_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS = 'SAVE_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS';
export const SAVE_BEFORE_AFTER_GALLERY_CONFIGS_FAILED = 'SAVE_BEFORE_AFTER_GALLERY_CONFIGS_FAILED';

export const GET_STORE_CONTACTS_CONFIGS_START = 'GET_STORE_CONTACTS_CONFIGS_START';
export const GET_STORE_CONTACTS_CONFIGS_SUCCESS = 'GET_STORE_CONTACTS_CONFIGS_SUCCESS';
export const GET_STORE_CONTACTS_CONFIGS_FAILED = 'GET_STORE_CONTACTS_CONFIGS_FAILED';

export const SAVE_STORE_CONTACTS_CONFIGS_START = 'SAVE_STORE_CONTACTS_CONFIGS_START';
export const SAVE_STORE_CONTACTS_CONFIGS_SUCCESS = 'SAVE_STORE_CONTACTS_CONFIGS_SUCCESS';
export const SAVE_STORE_CONTACTS_CONFIGS_FAILED = 'SAVE_STORE_CONTACTS_CONFIGS_FAILED';

export const SAVE_STORE_NAME_START = 'SAVE_STORE_NAME_START';
export const SAVE_STORE_NAME_SUCCESS = 'SAVE_STORE_NAME_SUCCESS';
export const SAVE_STORE_NAME_FAILED = 'SAVE_STORE_NAME_FAILED';

export const GET_STORE_EMAILS_CONFIGS_START = 'GET_STORE_EMAILS_CONFIGS_START';
export const GET_STORE_EMAILS_CONFIGS_SUCCESS = 'GET_STORE_EMAILS_CONFIGS_SUCCESS';
export const GET_STORE_EMAILS_CONFIGS_FAILED = 'GET_STORE_EMAILS_CONFIGS_FAILED';

export const CHANGE_STORE_EMAILS_CONFIGS = 'CHANGE_STORE_EMAILS_CONFIGS';

export const CREATE_MERCHANT_ACCOUNT_START = 'CREATE_MERCHANT_ACCOUNT_START';
export const CREATE_MERCHANT_ACCOUNT_SUCCESS = 'CREATE_MERCHANT_ACCOUNT_SUCCESS';
export const CREATE_MERCHANT_ACCOUNT_FAILED = 'CREATE_MERCHANT_ACCOUNT_FAILED';

export const GET_STORE_CONFIGS_SUMMARY_START = 'GET_STORE_CONFIGS_SUMMARY_START';
export const GET_STORE_CONFIGS_SUMMARY_SUCCESS = 'GET_STORE_CONFIGS_SUMMARY_SUCCESS';
export const GET_STORE_CONFIGS_SUMMARY_FAILED = 'GET_STORE_CONFIGS_SUMMARY_FAILED';

export const GET_STORE_EMAILS_STYLE_START = 'GET_STORE_EMAILS_STYLE_START';
export const GET_STORE_EMAILS_STYLE_SUCCESS = 'GET_STORE_EMAILS_STYLE_SUCCESS';
export const GET_STORE_EMAILS_STYLE_FAILED = 'GET_STORE_EMAILS_STYLE_FAILED';

export const GET_PAYMENT_INTEGRATIONS_START = 'GET_PAYMENT_INTEGRATIONS_START';
export const GET_PAYMENT_INTEGRATIONS_SUCCESS = 'GET_PAYMENT_INTEGRATIONS_SUCCESS';
export const GET_PAYMENT_INTEGRATIONS_FAILED = 'GET_PAYMENT_INTEGRATIONS_FAILED';

export const GET_STORE_EMAILS_CONFIGS_DATA_START = 'GET_STORE_EMAILS_CONFIGS_DATA_START';
export const GET_STORE_EMAILS_CONFIGS_DATA_SUCCESS = 'GET_STORE_EMAILS_CONFIGS_DATA_SUCCESS';
export const GET_STORE_EMAILS_CONFIGS_DATA_FAILED = 'GET_STORE_EMAILS_CONFIGS_DATA_FAILED';

export const SAVE_STORE_EMAILS_CONFIGS_DATA_START = 'SAVE_STORE_EMAILS_CONFIGS_DATA_START';
export const SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS = 'SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS';
export const SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED = 'SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED';

export const GET_REQUEST_ACCESS_CONFIGS_START = 'GET_REQUEST_ACCESS_CONFIGS_START';
export const GET_REQUEST_ACCESS_CONFIGS_SUCCESS = 'GET_REQUEST_ACCESS_CONFIGS_SUCCESS';
export const GET_REQUEST_ACCESS_CONFIGS_FAILED = 'GET_REQUEST_ACCESS_CONFIGS_FAILED';

export const GET_DEPOSIT_CONFIG_START = 'GET_DEPOSIT_CONFIG_START';
export const GET_DEPOSIT_CONFIG_SUCCESS = 'GET_DEPOSIT_CONFIG_SUCCESS';
export const GET_DEPOSIT_CONFIG_FAILED = 'GET_DEPOSIT_CONFIG_FAILED';

export const CHANGE_STORE_EMAILS_STYLE_TEMPLATE = 'CHANGE_STORE_EMAILS_STYLE_TEMPLATE';

export const SET_SETTINGS_ACTIVE_TAB = 'SET_SETTINGS_ACTIVE_TAB';

export const GET_SARP_UPDATE_CONFIG_START = 'GET_SARP_UPDATE_CONFIG_START';
export const GET_SARP_UPDATE_CONFIG_SUCCESS = 'GET_SARP_UPDATE_CONFIG_SUCCESS';
export const GET_SARP_UPDATE_CONFIG_FAILED = 'GET_SARP_UPDATE_CONFIG_FAILED';

export const getStoreConfigsStart = () => ({
  type: GET_STORE_CONFIGS_START
});

export const getStoreConfigsSuccess = (data) => ({
  type: GET_STORE_CONFIGS_SUCCESS,
  data
});

export const getStoreConfigsFailed = (error) => ({
  type: GET_STORE_CONFIGS_FAILED,
  error
});

export const updateStoreConfigsStart = () => ({
  type: UPDATE_STORE_CONFIGS_START
});

export const updateStoreConfigsSuccess = (data) => ({
  type: UPDATE_STORE_CONFIGS_SUCCESS,
  data
});

export const updateStoreSiteMapStart = () => ({
  type: UPDATE_STORE_SITE_MAP_START
});

export const updateStoreSiteMapSuccess = (data) => ({
  type: UPDATE_STORE_SITE_MAP_SUCCESS,
  data
});

export const updateStoreSiteMapFailed = (error) => ({
  type: UPDATE_STORE_SITE_MAP_FAILED,
  error
});

export const changeStoreConfig = (name, checked, targetType, value) => ({
  type: CHANGE_STORE_CONFIGS,
  name,
  checked,
  targetType,
  value
});

export const changeHomepagePromoCarouselConfig = (name, checked, targetType, value) => ({
  type: CHANGE_HOMEPAGE_PROMO_CAROUSEL_CONFIG,
  name,
  checked,
  targetType,
  value
});

export const changeHomepagePromoButtonCategory = (actionName, path, categoryId) => ({
  type: CHANGE_HOMEPAGE_CAROUSEL_BUTTON_CATEGORY,
  actionName,
  path,
  categoryId
});

export const updateStoreConfigsFailed = (error) => ({
  type: UPDATE_STORE_CONFIGS_FAILED,
  error
});

export const getHomepageWelcomeBlockConfigsStart = () => ({
  type: GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START
});

export const getHomepageWelcomeBlockConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS,
  data
});

export const getHomepageWelcomeBlockConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED,
  error
});

export const changeHomepageWelcomeBlockConfigConfig = (configPath, checked, configType, value) => ({
  type: CHANGE_HOMEPAGE_WELCOME_BLOCK_CONFIGS,
  configPath,
  checked,
  configType,
  value
});

export const saveHomepageWelcomeBlockConfigsStart = () => ({
  type: SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START
});

export const saveHomepageWelcomeBlockConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS,
  data
});

export const saveHomepageWelcomeBlockConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED,
  error
});

export const getHomepageInstagramBlockConfigsStart = () => ({
  type: GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START
});

export const getHomepageInstagramBlockConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS,
  data
});

export const getHomepageInstagramBlockConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED,
  error
});

export const changeHomepageInstagramBlockConfig = (configPath, checked, configType, value) => ({
  type: CHANGE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS,
  configPath,
  checked,
  configType,
  value
});

export const saveHomepageInstagramBlockConfigsStart = () => ({
  type: SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START
});

export const saveHomepageInstagramBlockConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS,
  data
});

export const saveHomepageInstagramBlockConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED,
  error
});


export const getHomepageBenefitsBlockConfigsStart = () => ({
  type: GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START
});

export const getHomepageBenefitsBlockConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS,
  data
});

export const getHomepageBenefitsBlockConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED,
  error
});

export const changeHomepageBenefitsBlockConfig = (configPath, checked, configType, value) => ({
  type: CHANGE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS,
  configPath,
  checked,
  configType,
  value
});

export const saveHomepageBenefitsBlockConfigsStart = () => ({
  type: SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START
});

export const saveHomepageBenefitsBlockConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS,
  data
});

export const saveHomepageBenefitsBlockConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED,
  error
});

export const getHomepageCTABlockConfigsStart = () => ({
  type: GET_HOMEPAGE_CTA_BLOCK_CONFIGS_START
});

export const getHomepageCTABlockConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS,
  data
});

export const getHomepageCTABlockConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED,
  error
});

export const changeHomepageCTABlockConfig = (configPath, checked, configType, value, configObject) => ({
  type: CHANGE_HOMEPAGE_CTA_BLOCK_CONFIGS,
  configPath,
  checked,
  configType,
  value,
  configObject
});

export const changeHomepageCTACategory = (actionType, value, configTab, configPath) => ({
  type: CHANGE_HOMEPAGE_CTA_CATEGORY,
  actionType,
  value,
  configTab,
  configPath
});

export const saveHomepageCTABlockConfigsStart = () => ({
  type: SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_START
});

export const saveHomepageCTABlockConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS,
  data
});

export const saveHomepageCTABlockConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED,
  error
});

export const getHomepageAdditionalHeaderConfigsStart = () => ({
  type: GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START
});

export const getHomepageAdditionalHeaderConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS,
  data
});

export const getHomepageAdditionalHeaderConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED,
  error
});

export const saveHomepageAdditionalHeaderConfigsStart = () => ({
  type: SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START
});

export const saveHomepageAdditionalHeaderConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS,
  data
});

export const saveHomepageAdditionalHeaderConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED,
  error
});


export const getHomepageAdditionalBannersConfigsStart = () => ({
  type: GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START
});

export const getHomepageAdditionalBannersConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS,
  data
});

export const getHomepageAdditionalBannersConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED,
  error
});

export const saveHomepageAdditionalBannersConfigsStart = () => ({
  type: SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START
});

export const saveHomepageAdditionalBannersConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS,
  data
});

export const saveHomepageAdditionalBannersConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED,
  error
});

export const getHomepageTestimonialsConfigsStart = () => ({
  type: GET_HOMEPAGE_TESTIMONIALS_CONFIGS_START
});

export const getHomepageTestimonialsConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS,
  data
});

export const getHomepageTestimonialsConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED,
  error
});

export const saveHomepageTestimonialsConfigsStart = () => ({
  type: SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_START
});

export const saveHomepageTestimonialsConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS,
  data
});

export const saveHomepageTestimonialsConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED,
  error
});

export const getHomepagePremiumCTAConfigsStart = () => ({
  type: GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_START
});

export const getHomepagePremiumCTAConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS,
  data
});

export const getHomepagePremiumCTAConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED,
  error
});

export const changeHomepagePremiumCTAConfig = (configPath, checked, configType, value, configObject) => ({
  type: CHANGE_HOMEPAGE_PREMIUM_CTA_CONFIGS,
  configPath,
  checked,
  configType,
  value,
  configObject
});

export const changeHomepagePremiumCTACategory = (actionType, value, configTab, configPath) => ({
  type: CHANGE_HOMEPAGE_PREMIUM_CTA_CATEGORY,
  actionType,
  value,
  configTab,
  configPath
});

export const saveHomepagePremiumCTAConfigsStart = () => ({
  type: SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_START
});

export const saveHomepagePremiumCTAConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS,
  data
});

export const saveHomepagePremiumCTAConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED,
  error
});

export const getHomepageBlogBlockConfigsStart = () => ({
  type: GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_START
});

export const getHomepageBlogBlockConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS,
  data
});

export const getHomepageBlogBlockConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED,
  error
});

export const saveHomepageBlogBlockConfigsStart = () => ({
  type: SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_START
});

export const saveHomepageBlogBlockConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS,
  data
});

export const saveHomepageBlogBlockConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED,
  error
});

export const getHomepageRewardBlockConfigsStart = () => ({
  type: GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_START
});

export const getHomepageRewardBlockConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS,
  data
});

export const getHomepageRewardBlockConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED,
  error
});

export const changeHomepageRewardBlockConfigConfig = (configPath, checked, configType, value) => ({
  type: CHANGE_HOMEPAGE_REWARD_BLOCK_CONFIGS,
  configPath,
  checked,
  configType,
  value
});

export const saveHomepageRewardBlockConfigsStart = () => ({
  type: SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_START
});

export const saveHomepageRewardBlockConfigsSuccess = (data) => ({
  type: SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS,
  data
});

export const saveHomepageRewardBlockConfigsFailed = (error) => ({
  type: SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED,
  error
});

export const getAppointmentBlockConfigsStart = () => ({
  type: GET_APPOINTMENT_FORM_CONFIGS_START
});

export const getAppointmentBlockConfigsSuccess = (data) => ({
  type: GET_APPOINTMENT_FORM_CONFIGS_SUCCESS,
  data
});

export const getAppointmentBlockConfigsFailed = (error) => ({
  type: GET_APPOINTMENT_FORM_CONFIGS_FAILED,
  error
});

export const changeAppointmentBlockConfig = (configPath, checked, configType, value) => ({
  type: CHANGE_APPOINTMENT_FORM_CONFIGS,
  configPath,
  checked,
  configType,
  value
});

export const saveAppointmentBlockConfigsStart = () => ({
  type: SAVE_APPOINTMENT_FORM_CONFIGS_START
});

export const saveAppointmentBlockConfigsSuccess = (data) => ({
  type: SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS,
  data
});

export const saveAppointmentBlockConfigsFailed = (error) => ({
  type: SAVE_APPOINTMENT_FORM_CONFIGS_FAILED,
  error
});

export const getAboutUsPageConfigsStart = () => ({
  type: GET_ABOUT_US_PAGE_CONFIGS_START
});

export const getAboutUsPageConfigsSuccess = (data) => ({
  type: GET_ABOUT_US_PAGE_CONFIGS_SUCCESS,
  data
});

export const getAboutUsPageConfigsFailed = (error) => ({
  type: GET_ABOUT_US_PAGE_CONFIGS_FAILED,
  error
});

export const changeAboutUsPageConfigConfig = (configPath, checked, configType, value, configObject) => ({
  type: CHANGE_ABOUT_US_PAGE_CONFIGS,
  configPath,
  checked,
  configType,
  value,
  configObject
});

export const saveAboutUsPageConfigsStart = () => ({
  type: SAVE_ABOUT_US_PAGE_CONFIGS_START
});

export const saveAboutUsPageConfigsSuccess = (data) => ({
  type: SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS,
  data
});

export const saveAboutUsPageConfigsFailed = (error) => ({
  type: SAVE_ABOUT_US_PAGE_CONFIGS_FAILED,
  error
});

export const getBeforeAfterGalleryConfigsStart = () => ({
  type: GET_BEFORE_AFTER_GALLERY_CONFIGS_START
});

export const getBeforeAfterGalleryConfigsSuccess = (data) => ({
  type: GET_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS,
  data
});

export const getBeforeAfterGalleryConfigsFailed = (error) => ({
  type: GET_BEFORE_AFTER_GALLERY_CONFIGS_FAILED,
  error
});

export const saveBeforeAfterGalleryConfigsStart = () => ({
  type: SAVE_BEFORE_AFTER_GALLERY_CONFIGS_START
});

export const saveBeforeAfterGalleryConfigsSuccess = (data) => ({
  type: SAVE_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS,
  data
});

export const saveBeforeAfterGalleryConfigsFailed = (error) => ({
  type: SAVE_BEFORE_AFTER_GALLERY_CONFIGS_FAILED,
  error
});

export const getStoreContactsConfigsStart = () => ({
  type: GET_STORE_CONTACTS_CONFIGS_START
});

export const getStoreContactsConfigsSuccess = (data) => ({
  type: GET_STORE_CONTACTS_CONFIGS_SUCCESS,
  data
});

export const getStoreContactsConfigsFailed = (error) => ({
  type: GET_STORE_CONTACTS_CONFIGS_FAILED,
  error
});

export const saveStoreContactsConfigsStart = () => ({
  type: SAVE_STORE_CONTACTS_CONFIGS_START
});

export const saveStoreContactsConfigsSuccess = (data) => ({
  type: SAVE_STORE_CONTACTS_CONFIGS_SUCCESS,
  data
});

export const saveStoreContactsConfigsFailed = (error) => ({
  type: SAVE_STORE_CONTACTS_CONFIGS_FAILED,
  error
});

export const saveStoreNameStart = () => ({
  type: SAVE_STORE_NAME_START
});

export const saveStoreNameSuccess = (data) => ({
  type: SAVE_STORE_NAME_SUCCESS,
  data
});

export const saveStoreNameFailed = (error) => ({
  type: SAVE_STORE_NAME_FAILED,
  error
});

export const getRewardBehaviorRulesStart = () => ({
  type: GET_REWARD_BEHAVIOR_RULES_START
});

export const getRewardBehaviorRulesSuccess = (data) => ({
  type: GET_REWARD_BEHAVIOR_RULES_SUCCESS,
  data
});

export const getRewardBehaviorRulesFailed = (error) => ({
  type: GET_REWARD_BEHAVIOR_RULES_FAILED,
  error
});

export const updateRewardBehaviorRuleStart = () => ({
  type: UPDATE_REWARD_BEHAVIOR_RULE_START
});

export const updateRewardBehaviorRuleSuccess = (data) => ({
  type: UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS,
  data
});

export const updateRewardBehaviorRuleFailed = (error) => ({
  type: UPDATE_REWARD_BEHAVIOR_RULE_FAILED,
  error
});

export const getFollowUpEmailsStart = () => ({
  type: GET_FOLLOW_UP_EMAILS_START
});

export const getFollowUpEmailsSuccess = (campaigns, events, emails) => ({
  type: GET_FOLLOW_UP_EMAILS_SUCCESS,
  campaigns,
  events,
  emails
});

export const getFollowUpEmailsFailed = () => ({
  type: GET_FOLLOW_UP_EMAILS_FAILED
});

export const changeCampaignEmailConfigs = (name, actionType, value, checked, emailId, eventId) => ({
  type: CHANGE_CAMPAIGN_EMAIL_CONFIGS,
  name,
  actionType,
  value,
  checked,
  emailId,
  eventId
});

export const saveNotificationOptionsStart = () => ({
  type: SAVE_NOTIFICATION_OPTIONS_START
});

export const saveNotificationOptionsSuccess = (data) => ({
  type: SAVE_NOTIFICATION_OPTIONS_SUCCESS,
  data
});

export const saveNotificationOptionsWarning = (data) => ({
  type: SAVE_NOTIFICATION_OPTIONS_WARNING,
  data
});

export const saveNotificationOptionsFailed = () => ({
  type: SAVE_NOTIFICATION_OPTIONS_FAILED
});

export const getSocialMediaConfigsStart = () => ({
  type: GET_SOCIAL_MEDIA_CONFIGS_START
});

export const getSocialMediaConfigsSuccess = (data) => ({
  type: GET_SOCIAL_MEDIA_CONFIGS_SUCCESS,
  data
});

export const getSocialMediaConfigsFailed = (error) => ({
  type: GET_SOCIAL_MEDIA_CONFIGS_FAILED,
  error
});

export const changeSocialMediaConfig = (name, value) => ({
  type: CHANGE_SOCIAL_MEDIA_CONFIG,
  name,
  value
});

export const saveSocialMediaConfigsStart = () => ({
  type: SAVE_SOCIAL_MEDIA_CONFIGS_START
});

export const saveSocialMediaConfigsSuccess = () => ({
  type: SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS
});

export const saveSocialMediaConfigsFailed = (error) => ({
  type: SAVE_SOCIAL_MEDIA_CONFIGS_FAILED,
  error
});

export const getSurveyQuestionConfigsStart = () => ({
  type: GET_SURVEY_QUESTION_CONFIGS_START
});

export const getSurveyQuestionConfigsSuccess = (data) => ({
  type: GET_SURVEY_QUESTION_CONFIGS_SUCCESS,
  data
});

export const getSurveyQuestionConfigsFailed = (error) => ({
  type: GET_SURVEY_QUESTION_CONFIGS_FAILED,
  error
});

export const changeSurveyQuestionConfig = (name, checked, targetType, value, data) => ({
  type: CHANGE_SURVEY_QUESTION_CONFIG,
  name,
  checked,
  targetType,
  value,
  data
});

export const getHomepagePromoCategoriesConfigsStart = () => ({
  type: GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_START
});

export const getHomepagePromoCategoriesConfigsSuccess = (data) => ({
  type: GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_SUCCESS,
  data
});

export const getHomepagePromoCategoriesConfigsFailed = (error) => ({
  type: GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_FAILED,
  error
});

export const getStoreEmailsConfigsStart = () => ({
  type: GET_STORE_EMAILS_CONFIGS_START
});

export const getStoreEmailsConfigsSuccess = (data) => ({
  type: GET_STORE_EMAILS_CONFIGS_SUCCESS,
  data
});

export const getStoreEmailsConfigsFailed = (error) => ({
  type: GET_STORE_EMAILS_CONFIGS_FAILED,
  error
});

export const changeStoreEmailConfigs = (checked, name) => ({
  type: CHANGE_STORE_EMAILS_CONFIGS,
  checked,
  name
});

export const createMerchantAccountStart = () => ({
  type: CREATE_MERCHANT_ACCOUNT_START,
});

export const createMerchantAccountSuccess = (data) => ({
  type: CREATE_MERCHANT_ACCOUNT_SUCCESS,
  data
});

export const createMerchantAccountFailed = (error) => ({
  type: CREATE_MERCHANT_ACCOUNT_FAILED,
  error
});

export const getStoreConfigsSummaryStart = () => ({
  type: GET_STORE_CONFIGS_SUMMARY_START,
});

export const getStoreConfigsSummarySuccess = (data) => ({
  type: GET_STORE_CONFIGS_SUMMARY_SUCCESS,
  data
});

export const getStoreConfigsSummaryFailed = (error) => ({
  type: GET_STORE_CONFIGS_SUMMARY_FAILED,
  error
});

export const getStoreEmailsStyleStart = () => ({
  type: GET_STORE_EMAILS_STYLE_START,
});

export const getStoreEmailsStyleSuccess = (data) => ({
  type: GET_STORE_EMAILS_STYLE_SUCCESS,
  data
});

export const getStoreEmailsStyleFailed = (error) => ({
  type: GET_STORE_EMAILS_STYLE_FAILED,
  error
});

export const changeStoreEmailsStyleTemplate = (value) => ({
  type: CHANGE_STORE_EMAILS_STYLE_TEMPLATE,
  value
});

export const setSettingsActiveTab = (data) => ({
  type: SET_SETTINGS_ACTIVE_TAB,
  data
});

export const getPaymentIntegrationsStart = () => ({
  type: GET_PAYMENT_INTEGRATIONS_START
});

export const getPaymentIntegrationsSuccess = (data) => ({
  type: GET_PAYMENT_INTEGRATIONS_SUCCESS,
  data
});

export const getPaymentIntegrationsFailed = (error) => ({
  type: GET_PAYMENT_INTEGRATIONS_FAILED,
  error
});

export const getStoreEmailsConfigsDataStart = () => ({
  type: GET_STORE_EMAILS_CONFIGS_DATA_START
});

export const getStoreEmailsConfigsDataSuccess = (data) => ({
  type: GET_STORE_EMAILS_CONFIGS_DATA_SUCCESS,
  data
});

export const getStoreEmailsConfigsDataFailed = (error) => ({
  type: GET_STORE_EMAILS_CONFIGS_DATA_FAILED,
  error
});

export const getRequestAccessConfigsStart = () => ({
  type: GET_REQUEST_ACCESS_CONFIGS_START
});

export const getRequestAccessConfigsSuccess = (data) => ({
  type: GET_REQUEST_ACCESS_CONFIGS_SUCCESS,
  data
});

export const getRequestAccessConfigsFailed = (error) => ({
  type: GET_REQUEST_ACCESS_CONFIGS_FAILED,
  error
});

export const getDepositConfigStart = () => ({
  type: GET_DEPOSIT_CONFIG_START
});

export const getDepositConfigSuccess = (data) => ({
  type: GET_DEPOSIT_CONFIG_SUCCESS,
  data
});

export const getDepositConfigFailed = (error) => ({
  type: GET_DEPOSIT_CONFIG_FAILED,
  error
});

export const saveStoreEmailsConfigsDataStart = () => ({
  type: SAVE_STORE_EMAILS_CONFIGS_DATA_START
});

export const saveStoreEmailsConfigsDataSuccess = (data) => ({
  type: SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS,
  data
});

export const saveStoreEmailsConfigsDataFailed = (error) => ({
  type: SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED,
  error
});

export const getSARPUpdateConfigStart = () => ({
  type: GET_SARP_UPDATE_CONFIG_START
});

export const getSARPUpdateConfigSuccess = (data) => ({
  type: GET_SARP_UPDATE_CONFIG_SUCCESS,
  data
});

export const getSARPUpdateConfigFailed = (error) => ({
  type: GET_SARP_UPDATE_CONFIG_FAILED,
  error
});
